import React, { useState, useEffect } from 'react';
import Light from './headers/light';
import { useNavigate } from 'react-router-dom';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import TabCardGrid2 from "./cards/TabCardGrid2";
import { useTranslation } from "react-i18next";

const Boutique = () => {
  const { t } = useTranslation(); // ✅ CORRECT PLACE

  const [role, setRole] = useState('');
    const [products, setProducts] = useState([]); // State for storing products
    const [cart, setCart] = useState([]); // State for managing the cart
    const [selectedCategory, setSelectedCategory] = useState('');
    const navigate = useNavigate(); // Initialize the useNavigate hook
    // Fetch products when the component mounts
    useEffect(() => {
        const userRole = localStorage.getItem('role');
        setRole(userRole); // Set the role state based on what’s stored
        const fetchProducts = async () => {
            try {
                const response = await fetch(`https://elanciabioapi.com/api/products`);
                if (!response.ok) {
                    throw new Error('Products not found');
                }
                const data = await response.json();
                setProducts(data);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        fetchProducts();
    }, []);

    // Handle "Ajouter au panier" functionality
    const handleAddToCart = (product) => {
        const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
        const productInCart = existingCart.find(item => item.productID === product.ProductID);
        
        if (productInCart) {
            // If the product already exists in the cart, increase its quantity
            productInCart.quantity += 1;
        } else {
            // Add the product to the cart with an initial quantity of 1
            existingCart.push({
                productID: product.ProductID,
                productName: product.Name,
                productImage: product.image,
                productPrice: product.Price,
                quantity: 1
            });
        }

        // Save updated cart to localStorage and update cart state
        localStorage.setItem('cart', JSON.stringify(existingCart));
        setCart(existingCart);
        alert('Produit ajouté au panier');
    };

    // Filter products based on selected category
    const filteredProducts = selectedCategory 
        ? products.filter(product => product.Category === selectedCategory)
        : products;
    const viewProductDetails = (productId) => {
            navigate(`/product-details/${productId}`); // Navigate to the product details page
        };
     const [product, setProduct] = useState([]);
     useEffect(() => {
          fetch("https://elanciabioapi.com/api/products")
            .then((response) => response.json())
            .then((data) => setProduct(Array.isArray(data) ? data : []))
            .catch((error) => console.error("Error fetching products alimentaire:", error));
        }, []);
    return (
        <AnimationRevealPage>
            <Light />
<TabCardGrid2
  heading={t("Our_products")}
  products={product}
/>
        </AnimationRevealPage>
    );
};

export default Boutique;
